import { useEffect, useRef, useState } from 'react';
import LocationCheck from '../icons/LocationCheck';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import Arrow from '../icons/Arrow';

const MapLocations = ({ t, ApiData = [], branchInView, setBranchInView }) => {
  const ref = useRef();
  const [show, setShow] = useState(false);
  useOnClickOutside(ref, () => setShow(false));
  const [inputValue, setInputValue] = useState('');
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    setBranches(
      ApiData.filter((item) =>
        item.name.toLowerCase().includes(inputValue.toLowerCase())
      )
    );
  }, [inputValue, ApiData]);

  return (
    <div
      onClick={() => setShow(!show)}
      className='relative order-last flex w-full min-w-36 cursor-pointer items-center justify-between rounded-xl border bg-zinc-100 p-2.5 lg:order-none lg:w-fit'
    >
      <LocationCheck className='size-5' />
      <p className='mx-3 flex-1 text-[15px]'>
        {branchInView?.name || t('Choose Your Location')}
      </p>
      <Arrow className='mt-0.5 size-2.5 rotate-90' />

      <div
        ref={ref}
        className={`${
          !show ? 'hidden' : 'block'
        }  absolute left-0 top-full z-50 w-full min-w-52 rounded-md border bg-white p-2 shadow-lg *:text-[15px] *:text-black`}
      >
        <input
          type='text'
          placeholder={t('Search for your City')}
          className='w-full rounded-md border border-gray-400 bg-gray-50 px-2 py-1 focus-visible:outline-none'
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onClick={(e) => e.stopPropagation()}
        />
        {/* {allCities?.data?.slice(1, allCities?.data?.length)?.map((item, key) => ( */}
        <ul className='gray-scroll my-1 max-h-80 overflow-y-auto'>
          {branches?.map((info, i) => (
            <li
              key={`map-location-${i}`}
              onClick={() => {
                setBranchInView(info);
              }}
              className={`hover:text-secondary-700 w-full p-2 hover:bg-gray-300 ${
                branches?.length - 1 === i ? 'mb-0' : 'mb-1.5 border-b'
              } `}
            >
              {info?.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MapLocations;
